import React from "react";

import { Divider } from "antd";

import { QuestionnaireProvider } from "@Totum/QuestionnaireBuilder/State/provider";

import Forms from "@Totum/QuestionnaireBuilder/UI/components/Forms";
import Header from "@Totum/QuestionnaireBuilder/UI/components/Header";

const QuestionnaireBuilder = () => (
    <QuestionnaireProvider>
        <div className="questionnaire-designer designer">
            <Header />

            <Divider />
            <Forms />
        </div>
    </QuestionnaireProvider>
);

export default QuestionnaireBuilder;
